export default __webpack_public_path__ + "media/images/svg/dog-decor-2-258efa6164c21c49d8b234791b09b6a9.svg";